
define('template!portalUsersRowTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<td class="email">' +
((__t = ( email )) == null ? '' : __t) +
'</td>\n<td class="name">' +
((__t = ( displayName )) == null ? '' : __t) +
'</td>\n<td class="status">\n  <span class="status-badge status-' +
((__t = ( status.toLowerCase() )) == null ? '' : __t) +
'">' +
((__t = ( statusLabel )) == null ? '' : __t) +
'</span>\n  ';
 if (locked) { ;
__p += '\n    <span class="status-badge status-locked">' +
((__t = ( _.i18n('portalUsers.locked', null, 'Locked') )) == null ? '' : __t) +
'</span>\n  ';
 } ;
__p += '\n</td>\n<td class="last-login">' +
((__t = ( lastLoginLabel )) == null ? '' : __t) +
'</td>\n<td class="notify">\n  ';
 if (status !== 'DISABLED') { ;
__p += '\n    <label class="notify-toggle" title="' +
((__t = ( _.i18n('portalUsers.notifyHint', null, 'Gets an email each time a new order lands on the portal') )) == null ? '' : __t) +
'">\n      <input type="checkbox" class="js-notify" ' +
((__t = ( notifyNewOrders ? 'checked' : '' )) == null ? '' : __t) +
'>\n    </label>\n  ';
 } ;
__p += '\n</td>\n<td class="actions">\n  ';
 if (status !== 'DISABLED') { ;
__p += '\n    <button type="button" class="btn btn-sm js-invite">' +
((__t = ( inviteLabel )) == null ? '' : __t) +
'</button>\n  ';
 } ;
__p += '\n  ';
 if (locked) { ;
__p += '\n    <button type="button" class="btn btn-sm js-unlock">' +
((__t = ( _.i18n('portalUsers.unlock', null, 'Unlock') )) == null ? '' : __t) +
'</button>\n  ';
 } ;
__p += '\n  ';
 if (status === 'DISABLED') { ;
__p += '\n    <button type="button" class="btn btn-sm js-enable">' +
((__t = ( _.i18n('portalUsers.enable', null, 'Reopen') )) == null ? '' : __t) +
'</button>\n  ';
 } else { ;
__p += '\n    <button type="button" class="btn btn-sm js-disable">' +
((__t = ( _.i18n('portalUsers.disable', null, 'Revoke access') )) == null ? '' : __t) +
'</button>\n  ';
 } ;
__p += '\n</td>\n';

}
return __p
};});

